import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { recordConsentFunnelAction } from '../utils/consentExperiment';
import './TrackingNotice.css';

export default function TrackingNotice({ consent }) {
  const notice = window.LVMTrackingNotice;
  const [dismissed, setDismissed] = useState(() => notice.acknowledged());
  const ref = useRef(null);
  const recorded = useRef(false);
  const visible = !dismissed && consent.status === 'notice' && !consent.verifiedEmbedReturn;
  useEffect(() => {
    const sync = () => setDismissed(notice.acknowledged());
    window.addEventListener(notice.changeEvent, sync);
    return () => window.removeEventListener(notice.changeEvent, sync);
  }, [notice]);
  useEffect(() => {
    if (recorded.current || consent.authority === 'pending_embed_binding') return;
    recorded.current = true;
    recordConsentFunnelAction('tracking_visit');
    if (consent.status === 'notice') {
      recordConsentFunnelAction('eligible_visit');
      recordConsentFunnelAction('default_on', { selection: 'marketing_only' });
    }
  }, [consent]);
  useLayoutEffect(() => {
    if (!visible || !ref.current) return undefined;
    recordConsentFunnelAction('banner_impression');
    return notice.protectPurchaseJourney(ref.current);
  }, [visible, notice]);
  if (!visible) return null;
  return (
    <section className="tracking-notice" aria-label="Privacy information" ref={ref}>
      <p>{notice.copy}{' '}<Link to={notice.privacyUrl('/privacy')}>Privacy information</Link></p>
      <button type="button" onClick={() => {
        if (!notice.acknowledge()) recordConsentFunnelAction('storage_failure');
        recordConsentFunnelAction('notice_acknowledged');
        setDismissed(true);
      }}>Got it</button>
    </section>
  );
}
